import React, { PureComponent } from 'react';

class RotatedAxisTick extends PureComponent {
	render() {
		const { x, y, payload, formatter } = this.props;
		let text = payload.value;
		if (formatter && typeof formatter === 'function') {
			text = formatter(text);
		}

		return (
			<g transform={`translate(${x},${y})`}>
				<text x={0} y={0} dy={10} textAnchor='end' fill='#666' transform="rotate(-35)">{text}</text>
			</g>
		);
	}
}

export default RotatedAxisTick;